document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('#top_mv_slide .top_mv_swiper');
  if (!swiperEl) return;

  // 少し遅延させて初期化
  setTimeout(() => {
    new Swiper('.top_mv_swiper', {
      loop: true,
      loopedSlides: 3, // ← 追加
      
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      speed: 500,
      slidesPerGroup: 1,
      grabCursor: true,

      // pagination: {
//   el: '.swiper-pagination',
//   clickable: true,
// },


      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        600: {
          slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: 16,
        },
      },
    });
  }, 100);
});
